import React, {Component} from 'react';
import Errors from '../common/Errors'
import {Link} from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import * as AppConstant from '../common/AppConstant'
import {Redirect} from 'react-router-dom';

class SignatureSetting extends Component {

    constructor(props) {
        super(props);
        this.state = {
            signatureSetting: {
                assignTemplateToUsers:false,
                googleDriveUploadEnable: false,
                enableSigningOrder: false,
                enableSignWithIp: false,
                reminderDays1: null,
                reminderDays2: null,
                reminderDays3: null,
                reminderDays4: null,
                reminderDays5: null,
            },
            loggedInUser:{},
            redirectToDashBoard:false,
            disabledButton: false,
            redirectToErrorPage: false,
            redirectToForbiddenPage: false,
            apiStatus: {
                isError: false,
                message: ''
            },
            errorMessage: '',
            showLoader: false
        };
        this.fetchSignatureSetting = this.fetchSignatureSetting.bind(this);
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            element: false
        });
    }
    componentDidMount(){
        this.fetchLoggedInStaff();
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchSignatureSetting();
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }
    fetchSignatureSetting() {
        this.setState({showLoader:true});
        fetch(this.props.api + '/signatureSetting', {
            method: "GET",
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                if (json.isError === false){
                    const signatureSetting = json.signatureSetting;
                    this.setState({signatureSetting: signatureSetting,showLoader: false});
                }else{
                    this.setState({showLoader: false});
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({redirectToForbiddenPage: true});
                    }
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({showLoader:false});
            });
    }
    handleChange(event) {
        const {signatureSetting} = this.state;
        const target = event.target;
        const name = target.name;
        const value = target.value;
        signatureSetting[name] = value;
        console.log(name + " === " + value + " ===  ");
        this.setState({signatureSetting: signatureSetting});
    }
    checkBoxChange(event) {
        const target = event.target;
        const name = target.name;
        const {signatureSetting} = this.state;
        signatureSetting[name] = event.target.checked;
        this.setState({signatureSetting: signatureSetting});

    }
    handleSubmit(event) {
        event.preventDefault();
        console.log(this.validator.allValid());
        if (this.validator.allValid()) {
            this.setState({showLoader:true});
            fetch(this.props.api + '/signatureSetting', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.state.signatureSetting),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    const {apiStatus}  = this.state;
                    if (json && json.isError === false) {
                        apiStatus.isError = false;
                        apiStatus.message = "Signature Setting Successfully Saved";
                    } else {
                        apiStatus.isError = true;
                        apiStatus.message = json.message;
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                            this.setState({showLoader: false, redirectToForbiddenPage: true});
                        }
                    }
                    this.setState({disabledButton: false, apiStatus: apiStatus, showLoader:false, redirectToDashBoard:(apiStatus.isError === false ? true : false)});
                })
                .catch(error => {
                    const {apiStatus}  = this.state;
                    apiStatus.isError = true;
                    apiStatus.message = error;
                    this.setState({disabledButton: false, apiStatus: apiStatus,showLoader:false});
                    console.log(error);
                });
        }else{
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    render() {
        let _this = this;
        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {
                    (this.state.redirectToDashBoard && this.state.apiStatus && this.state.apiStatus.message) ? (<Redirect to={'/msg/'+this.state.apiStatus.message}/>) : null
                }
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('signatureSetting.label.header')}</p>
                            </div>
                            <div className="table-box table-responsive p-m" style={{minHeight:'490px'}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                <form onSubmit={this.handleSubmit} className="form-horizontal">
                                    <div className="col-md-12">
                                        <div className="row m-t-sm">
                                            <div className="col-lg-12">
                                                <div className="panel blank-panel">
                                                    <div className="panel-heading">
                                                        <div className="panel-options">
                                                            <ul className="nav nav-tabs">
                                                                <li className="active"><a href="#tab-1" data-toggle="tab">Signature/Template</a></li>
                                                                <li className=""><a href="#tab-2" data-toggle="tab">Reminder Email</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div className="panel-body">

                                                        <div className="tab-content">
                                                            <div className="tab-pane active" id="tab-1">
                                                                <div className="form-group">
                                                                    <label className="col-sm-2 control-label">Merge Signature With IP and Date</label>
                                                                    <div className="col-sm-10">
                                                                        <div>
                                                                            <label> <input type="checkbox" id="enableSignWithIp" name="enableSignWithIp"
                                                                                           checked={this.state.signatureSetting.enableSignWithIp === null ? false : this.state.signatureSetting.enableSignWithIp}
                                                                                           onChange={this.checkBoxChange}/> If enabled then Recipient's Signature will have IP and Signed Date </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label className="col-sm-2 control-label">Enable Signing Order</label>
                                                                    <div className="col-sm-10">
                                                                        <div>
                                                                            <label> <input type="checkbox"  id="enableSigningOrder" name="enableSigningOrder"
                                                                                           checked={this.state.signatureSetting.enableSigningOrder === null ? false : this.state.signatureSetting.enableSigningOrder}
                                                                                           onChange={this.checkBoxChange}/> If enabled then Recipients will recieve review email in set order </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/*<div className="form-group">
                                                                    <label className="col-sm-2 control-label">Enable Google Drive Upload</label>
                                                                    <div className="col-sm-10">
                                                                        <div>
                                                                            <label> <input type="checkbox"  id="googleDriveUploadEnable" name="googleDriveUploadEnable"
                                                                                           checked={this.state.signatureSetting.googleDriveUploadEnable === null ? false : this.state.signatureSetting.googleDriveUploadEnable}
                                                                                           onChange={this.checkBoxChange}/> If enabled then user can upload file from Google Drive </label>
                                                                        </div>
                                                                    </div>
                                                                </div>*/}
                                                            </div>
                                                            <div className="tab-pane" id="tab-2">

                                                                <div className="col-md-12">
                                                                    <div className="col-md-12">
                                                                        <div className="form-group" style={{color:"blue",fontWeight:"bold"}}>
                                                                            <p>{_this.props.msg('emailConfig.label.reminderEmailDescription')}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="col-md-12">
                                                                        <div className="form-group row">
                                                                            <label className="col-lg-2 control-label"
                                                                                   style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder1')}</label>

                                                                            <div className="col-lg-2">
                                                                                <input type="number" id="reminderDays1" className="form-control" style={{width:'140px'}} name="reminderDays1"
                                                                                       onChange={_this.handleChange} value={this.state.signatureSetting.reminderDays1 === null ? '' : this.state.signatureSetting.reminderDays1} placeholder="Enter days"/>
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-group row">
                                                                            <label className="col-lg-2 control-label"
                                                                                   style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder2')}</label>

                                                                            <div className="col-lg-2">
                                                                                <input type="number" id="reminderDays2" className="form-control" style={{width:'140px'}} name="reminderDays2"
                                                                                       onChange={_this.handleChange} value={this.state.signatureSetting.reminderDays2 === null ? '' : this.state.signatureSetting.reminderDays2} placeholder="Enter days"/>
                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="form-group row">
                                                                            <label className="col-lg-2 control-label"
                                                                                   style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder3')}</label>

                                                                            <div className="col-lg-2">
                                                                                <input type="number" id="reminderDays3" className="form-control" style={{width:'140px'}} name="reminderDays3"
                                                                                       onChange={_this.handleChange} value={this.state.signatureSetting.reminderDays3 === null ? '' : this.state.signatureSetting.reminderDays3} placeholder="Enter days"/>
                                                                            </div>
                                                                            </div>
                                                                             <div className="form-group row">
                                                                            <label className="col-lg-2 control-label"
                                                                                   style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder4')}</label>

                                                                            <div className="col-lg-2">
                                                                                <input type="number" id="reminderDays4" className="form-control" style={{width:'140px'}} name="reminderDays4"
                                                                                       onChange={_this.handleChange} value={this.state.signatureSetting.reminderDays4 === null ? '' : this.state.signatureSetting.reminderDays4} placeholder="Enter days"/>
                                                                            </div>
                                                                             </div>

                                                                        <div className="form-group row">
                                                                            <label className="col-lg-2 control-label"
                                                                                   style={{textAlign:'left'}}>{_this.props.msg('emailConfig.label.emailReminder5')}</label>

                                                                            <div className="col-lg-2">
                                                                                <input type="number" id="reminderDays5" className="form-control" style={{width:'140px'}} name="reminderDays5"
                                                                                       onChange={_this.handleChange} value={this.state.signatureSetting.reminderDays5 === null ? '' : this.state.signatureSetting.reminderDays5} placeholder="Enter days"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <Link to="/" className="btn btn-white">{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                            <input className="btn btn-primary" type="submit" value={_this.props.msg('form.label.submit')}
                                                   disabled={this.state.disabledButton===true}/>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default SignatureSetting;


// WEBPACK FOOTER //
// ./src/components/organization/SignatureSetting.js